// Service de cache avec cookies pour les informations de l'entreprise
class CacheService {
  constructor() {
    this.cacheExpiry = 24 * 60 * 60 * 1000; // 24 heures en millisecondes
  }

  // Générer une clé de cache
  getCacheKey(key) {
    return `ats_cache_${key}`;
  }

  // Sauvegarder des données dans les cookies
  setCache(key, data) {
    try {
      const cacheKey = this.getCacheKey(key);
      const cacheData = {
        data: data,
        timestamp: Date.now(),
        expiry: this.cacheExpiry
      };
      
      const serializedData = JSON.stringify(cacheData);
      document.cookie = `${cacheKey}=${encodeURIComponent(serializedData)}; path=/; max-age=${this.cacheExpiry / 1000}; SameSite=Strict`;
      
      return true;
    } catch (error) {
      return false;
    }
  }

  // Récupérer des données depuis les cookies
  getCache(key) {
    try {
      const cacheKey = this.getCacheKey(key);
      const cookies = document.cookie.split(';');
      
      for (let cookie of cookies) {
        const [cookieKey, cookieValue] = cookie.trim().split('=');
        if (cookieKey === cacheKey) {
          const decodedValue = decodeURIComponent(cookieValue);
          const cacheData = JSON.parse(decodedValue);
          
          // Vérifier si le cache n'est pas expiré
          if (Date.now() - cacheData.timestamp < cacheData.expiry) {
            return cacheData.data;
          } else {
            // Supprimer le cache expiré
            this.removeCache(key);
            return null;
          }
        }
      }
      
      return null;
    } catch (error) {
      return null;
    }
  }

  // Supprimer un cache spécifique
  removeCache(key) {
    try {
      const cacheKey = this.getCacheKey(key);
      document.cookie = `${cacheKey}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
      return true;
    } catch (error) {
      return false;
    }
  }

  // Vérifier si un cache existe et n'est pas expiré
  hasCache(key) {
    return this.getCache(key) !== null;
  }

  // Nettoyer tous les caches expirés
  cleanExpiredCache() {
    try {
      const cookies = document.cookie.split(';');
      const now = Date.now();
      
      for (let cookie of cookies) {
        const [cookieKey, cookieValue] = cookie.trim().split('=');
        if (cookieKey.startsWith('ats_cache_')) {
          try {
            const decodedValue = decodeURIComponent(cookieValue);
            const cacheData = JSON.parse(decodedValue);
            
            if (now - cacheData.timestamp >= cacheData.expiry) {
              const key = cookieKey.replace('ats_cache_', '');
              this.removeCache(key);
            }
          } catch (error) {
            // Supprimer les cookies corrompus
            document.cookie = `${cookieKey}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
          }
        }
      }
    } catch (error) {
      }
  }

  // Obtenir la taille du cache
  getCacheSize() {
    try {
      const cookies = document.cookie.split(';');
      let size = 0;
      
      for (let cookie of cookies) {
        const [cookieKey] = cookie.trim().split('=');
        if (cookieKey.startsWith('ats_cache_')) {
          size++;
        }
      }
      
      return size;
    } catch (error) {
      return 0;
    }
  }

  // Clés de cache spécifiques pour l'application
  static get KEYS() {
    return {
      COMPANY_INFO: 'company_info',
      COMPANY_LOGO: 'company_logo',
      NAVBAR_DATA: 'navbar_data',
      HOME_DATA: 'home_data',
      CONTACT_DATA: 'contact_data',
      DEVIS_DATA: 'devis_data'
    };
  }
}

// Instance singleton
const cacheService = new CacheService();

// Nettoyer les caches expirés au démarrage
if (typeof window !== 'undefined') {
  cacheService.cleanExpiredCache();
}

export default cacheService; 